const state_ = () => ({
    items: [],
    pages: [],
    meta: [],
    current: false,
    currentId: false,
});


const getters_ = {
    pages(state) {
        return state.pages
    },
    meta(state) {
        return state.meta
    },
    items(state) {
        return state.items
    },
    currentId(state) {
        return state.currentId
    },
    current(state) {
        return state.current
    },
}

const actions_ = {
    async list({commit}, data) {
        let result = await this.$api.discounts.list(data)
        if (!result || typeof result.data == 'undefined') {
            return false
        }
        const answer = result.data;
        commit('setItems', answer)
        commit('setPages', result.links)
        commit('setMeta', result.meta)
        return answer
    },
    async add(fields, data) {
        console.info(data)
        fields = JSON.parse(JSON.stringify(data));
        fields.json_data = JSON.stringify(fields.json_data);
        let result = await this.$api.discounts.add(fields)
        if (!result || typeof result.data == 'undefined') {
            return false
        }
        const answer = result.data;
        return answer
    },
    async update({dispatch}, data) {
        if (data.id == 'add') {
            return await dispatch('add', data)
        }
        var fields = JSON.parse(JSON.stringify(data));
        fields.json_data = JSON.stringify(fields.json_data);
        let result = await this.$api.discounts.update(fields.id, fields)
        if (!result || typeof result.data == 'undefined') {
            return false
        }
        const answer = result.data;
        return answer
    },
};

const mutations_ = {
    setItems(state, items) {
        for (var i in items) {
            items[i].is_active = !!items[i].is_active;
            items[i].json_data = JSON.parse(items[i].json_data);
            items[i].json_data = items[i].json_data ? items[i].json_data : {};
            items[i].from_text = items[i].from ? (new Date(items[i].from)).toLocaleDateString() : '';
            items[i].to_text = items[i].to ? (new Date(items[i].to)).toLocaleDateString() : '';
        }
        state.items = items;
    },
    setPages(state, data) {
        state.pages = data
    },
    setMeta(state, data) {
        state.meta = data
    },
};
export const actions = actions_;
export const state = state_;
export const mutations = mutations_;
export const getters = getters_;
